import RentalVersionData from '../../types/RentalVersionData';
import AppState from '../../types/AppState';
import { ThunkAction } from 'redux-thunk';
import { RentalFormActionTypes } from './types';
import { setErrors } from '../dashboardActionCreators';
import { normalizeCurrentRentalVersion } from './normalizeCurrentRentalVersion';
import { fetchPricing } from './fetchPricing';
import { toggleLoadingPricing } from './toggleLoadingPricing';
import axios from 'axios';
import { UPDATE_RENTAL_FORM_V2_SUCCESS } from '../../constants/redux';

export const updateCurrentRentalVersion = (
  payload: Partial<RentalVersionData>
): ThunkAction<
  Promise<void>,
  AppState,
  unknown,
  RentalFormActionTypes
> => async (dispatch: any, getState: any) => {
  const id = getState().rentalFormV2.id;

  if (!id) return Promise.resolve();

  dispatch({
    type: UPDATE_RENTAL_FORM_V2_SUCCESS,
    payload,
  });

  try {
    await dispatch(normalizeCurrentRentalVersion(payload));
  } catch (error) {
    dispatch(
      setErrors(
        'An error occurred while calculating delivery cost. Please fill your delivery address one more time. If the problem persists, please use a Custom Delivery Cost or contact support.'
      )
    );
  }

  let cancelToken = getState().rentalFormV2.pricingCancelToken;

  if (cancelToken) {
    cancelToken.cancel('Operation canceled due to new request.');
  }

  cancelToken = axios.CancelToken.source();

  dispatch(toggleLoadingPricing(true, cancelToken));
  dispatch(fetchPricing(cancelToken.token))
    .then(() => {
      dispatch(toggleLoadingPricing(false, undefined));
    })
    .catch(() => {});

  return Promise.resolve();
};
